import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import TwoButtonModal from './TwoButtonModal';

interface Props {
  presenter: any;
  onCancelClicked: Function;
  onStopClicked: Function;
  intl: any;
}

const StopPresenterModal: React.SFC<Props> = (props) => {
  const messages = defineMessages({
    title: { id: 'components.stopPresenterModal.title', defaultMessage: 'Stop Presentation' },
    message: {
      id: 'components.stopPresenterModal.message',
      defaultMessage: 'Are you sure you want to stop {name} from presenting?'
    },
    cancel: { id: 'components.stopPresenterModal.cancel', defaultMessage: 'Cancel' },
    accept: { id: 'components.stopPresenterModal.accept', defaultMessage: 'Yes, stop' }
  });

  return (
    <TwoButtonModal
      title={props.intl.formatMessage(messages.title)}
      message={props.intl.formatMessage(messages.message, { name: props.presenter.name })}
      primaryButtonText={props.intl.formatMessage(messages.accept)}
      secondaryButtonText={props.intl.formatMessage(messages.cancel)}
      onPrimaryButtonClick={() => props.onStopClicked(props.presenter)}
      onSecondaryButtonClick={() => props.onCancelClicked()}
    />
  );
};

export default injectIntl(StopPresenterModal);
